export default {
  '&TrackedSweetenerForm.Accept': 'Download',
  '&TrackedSweetenerForm.Decline': 'No Thanks',
  '&TrackedSweetenerForm.Thanks': 'Thank you!',
} as TextDictionary;
